import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./app.js";
import "./styles/globals.css";

// Stale-chunk recovery. Routes are code-split (React.lazy → dynamic import). After
// a new deploy replaces the hashed asset files, a tab still holding the previous
// index.html will 404 when it lazy-loads a route chunk ("Failed to fetch
// dynamically imported module"). Vite fires `vite:preloadError` for exactly this
// — reload once to fetch the fresh manifest. The time-boxed guard prevents a
// reload loop if a chunk is genuinely broken (rather than just stale).
window.addEventListener("vite:preloadError", () => {
  const KEY = "vite:preloadError:lastReload";
  const now = Date.now();
  const last = Number(sessionStorage.getItem(KEY) ?? "0");
  if (now - last > 10_000) {
    sessionStorage.setItem(KEY, String(now));
    window.location.reload();
  }
  // Else: we reloaded very recently — let the error surface instead of looping.
});

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
